import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Blog from "@/pages/Blog";
import { fetchBlogList, blogPreloadLinks } from "@/lib/blogList";

export const Route = createFileRoute("/blog/")({
  loader: () => fetchBlogList(),
  head: ({ loaderData }) => ({ ...routeHead('AGAPE Blog — AI, Sales & Operations', META_DESCRIPTIONS.blog.en, '/blog'), links: blogPreloadLinks(loaderData) }),
  component: BlogRoute,
});

function BlogRoute() {
  const { posts, categories } = Route.useLoaderData();
  return <Blog posts={posts} categories={categories} />;
}
